import { Skeleton, Box, useTheme } from '@mui/material';
import React, { FC } from 'react';

const FAQSSectionSkeleton: FC<any> = () => {
    const theme = useTheme();
  
  return (
    <Box py={8}>
       <Skeleton variant="text" width="300px" height={70} />
     <Box
             sx={{
               mt: 2,
               mb: 2,
               backgroundColor: theme.palette.divider,
               border: `1px solid ${theme.palette.divider[4]}`,
               padding: theme.spacing(2.5, 3),
               borderRadius: theme.spacing(0.5),
             }}>
             <Skeleton variant="text" width="60%" height={30} sx={{ mb: 2 }} />
             <Skeleton variant="text" width="100%" height={20} />
             <Skeleton variant="text" width="100%" height={20} />
             <Skeleton variant="text" width="30%" height={20} />
           </Box>
     
         {[...Array(4)].map((_, item) => (
             <Box
               key={item}
               sx={{
                 mb: 2,
                 backgroundColor: theme.palette.divider,
                 border: `1px solid ${theme.palette.divider[4]}`,
                 padding: theme.spacing(2.5, 3),
                 borderRadius: theme.spacing(0.5),
               }}>
               <Skeleton variant="text" width="60%" height={30} />
             </Box>
           ))}
        <Skeleton variant="text" width="200px" height={70} />
     </Box>
  );
};

export { FAQSSectionSkeleton };